import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useMovePost, useSpace } from '@tribeplatform/react-sdk/hooks';
import { Alert } from '@tribeplatform/react-ui-kit/Alert';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { logger } from '../common/lib/logger';
import { Form } from '../Form';
import { T, useI18n } from '../i18n';
export const MovePostModal = ({ post, open, onClose }) => {
    var _a, _b, _c, _d;
    const intl = useI18n();
    const [space, setSpace] = useState();
    const isSameSpace = (space === null || space === void 0 ? void 0 : space.id) && ((_a = post === null || post === void 0 ? void 0 : post.space) === null || _a === void 0 ? void 0 : _a.id) === (space === null || space === void 0 ? void 0 : space.id);
    const isPrivate = space === null || space === void 0 ? void 0 : space.private;
    const { data: fullSpace } = useSpace({
        variables: {
            id: space === null || space === void 0 ? void 0 : space.id,
        },
        fields: {
            authMemberProps: {
                availablePostTypes: 'all',
            },
        },
        useQueryOptions: {
            enabled: !!(space === null || space === void 0 ? void 0 : space.id),
        },
    });
    const { mutateAsync: movePost, isLoading } = useMovePost();
    const isFullSpaceLoaded = typeof ((_b = fullSpace === null || fullSpace === void 0 ? void 0 : fullSpace.authMemberProps) === null || _b === void 0 ? void 0 : _b.availablePostTypes) !== 'undefined';
    const isPostTypeSupported = !!((_d = (_c = fullSpace === null || fullSpace === void 0 ? void 0 : fullSpace.authMemberProps) === null || _c === void 0 ? void 0 : _c.availablePostTypes) === null || _d === void 0 ? void 0 : _d.find(postType => (postType === null || postType === void 0 ? void 0 : postType.id) === (post === null || post === void 0 ? void 0 : post.postTypeId)));
    return (_jsxs(Modal, { open: open, onClose: onClose, children: [_jsx(Modal.Header, { title: intl.$t({
                    id: 'Post.MovePostModal.HeaderTitle',
                    defaultMessage: 'Move post to another {SPACE}',
                }) }, void 0), _jsx(Modal.Content, { children: _jsxs(Form, { onSubmit: async (data) => {
                        if (!(post === null || post === void 0 ? void 0 : post.id) || !(space === null || space === void 0 ? void 0 : space.id))
                            return;
                        try {
                            await movePost({
                                id: post === null || post === void 0 ? void 0 : post.id,
                                spaceId: space === null || space === void 0 ? void 0 : space.id,
                                sendNotification: data.sendNotification,
                            });
                            toast({
                                title: intl.$t({
                                    id: 'Post.MovePostModal.PostMovedSuccessTitle',
                                    defaultMessage: 'The post was moved successfully.',
                                }),
                                status: 'success',
                            });
                            onClose();
                        }
                        catch (err) {
                            toast({
                                title: intl.$t({
                                    id: 'Post.MovePostModal.PostMoveFailedTitle',
                                    defaultMessage: 'Unable to move the post at this time.',
                                }),
                                status: 'error',
                            });
                            logger.error('Move post failed', err);
                        }
                    }, className: "flex flex-col space-y-5", defaultValues: {
                        target: space,
                    }, children: [_jsx(Form.SpacePicker, { label: intl.$t({
                                id: 'Post.MovePostModal.SpacePickerLabel',
                                defaultMessage: 'Move to',
                            }), onChange: space => setSpace(space), name: "target", placeholder: intl.$t({
                                id: 'Post.MovePostModal.SpacePickerPlaceholder',
                                defaultMessage: 'Select a {SPACE}...',
                            }) }, void 0), isSameSpace && (_jsx(Alert, { status: "info", children: _jsx(T, { id: "Post.MovePostModal.PostAlreadySameSpaceHint", defaultMessage: "This post is already in this {SPACE}. Please select another {SPACE}." }, void 0) }, void 0)), !isSameSpace && isPrivate && (_jsx(Alert, { status: "info", children: _jsx(T, { id: "Post.MovePostModal.MovingPostToPrivateSpaceHint", defaultMessage: "You are moving this post to a private {SPACE}. This means the author or participants of this post may not be able to access the post." }, void 0) }, void 0)), !isPostTypeSupported && isFullSpaceLoaded && (_jsx(Alert, { status: "warning", children: _jsx(T, { id: "Post.MovePostModal.PostTypeNotSupportedHint", defaultMessage: "You cannot move the post since the post type is not supported in this {SPACE}." }, void 0) }, void 0)), _jsx(Form.Checkbox, { label: intl.$t({
                                id: 'Post.MovePostModal.SendNotifToDestinationMembersCheckBoxLabel',
                                defaultMessage: 'Send notification to the destination {SPACE} {MEMBERS}',
                            }), name: "sendNotification" }, void 0), _jsxs(Form.Actions, { children: [_jsx(Button, { type: "submit", disabled: !(space === null || space === void 0 ? void 0 : space.id) ||
                                        isSameSpace ||
                                        !isFullSpaceLoaded ||
                                        !isPostTypeSupported, loading: isLoading || ((space === null || space === void 0 ? void 0 : space.id) && !isFullSpaceLoaded), children: _jsx(T, { id: "Generics.Move", defaultMessage: "Move" }, void 0) }, void 0), _jsx(Button, { variant: "outline", onClick: () => onClose(), children: _jsx(T, { id: "Generics.Cancel", defaultMessage: "Cancel" }, void 0) }, void 0)] }, void 0)] }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=MovePostModal.js.map